// @flow
import React from 'react';
import styles from './PlanImage.css';
import classNames from 'classnames';
import IconLabel from '../util/IconLabel';
import { injectIntl } from 'react-intl';
import { commonMessages } from '../messages/Common';
import type { IntlShape } from 'react-intl';

type OwnProps = {
  id: string,
  isSelected: boolean,
  imageTitle: string,
  planTag?: React$Element<any>,
};

type Props = OwnProps & {
  intl: IntlShape,
};

const PlanImage = ({ id, isSelected, imageTitle, intl, planTag }: Props) => {
  return (
    <figure
      className={classNames(styles.container, styles[`container--${id}`])}
      aria-label={
        isSelected
          ? intl.formatMessage(commonMessages.deselect, { title: imageTitle })
          : intl.formatMessage(commonMessages.select, { title: imageTitle })
      }
    >
      {planTag && <div className={styles.planTag}>{planTag}</div>}
      {isSelected ? (
        <IconLabel className={styles.icon} name="check" size="medium" />
      ) : (
        <div className={classNames(styles.icon, styles.circle)} />
      )}
      <span className={styles.title}>{imageTitle}</span>
    </figure>
  );
};

export default injectIntl(PlanImage);
